<div class="page-layout">
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Settings"
      pageSubtitle="Manage your workspace settings, security, and connected services."
    ></app-navbar>

    <div class="content">
      <!-- Profile -->
      <div class="settings-card">
        <div class="card-header">
          <div class="header-left">
            <div class="header-icon blue-bg">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <h3 class="card-title">Profile</h3>
          </div>
          <app-button variant="secondary" size="sm" (clicked)="onUpdateProfile()">Update</app-button>
        </div>

        <div class="card-body profile-grid">
          <app-text-input
            label="Full Name"
            labelStyle="normal"
            [value]="fullName()"
            (valueChange)="fullName.set($event)"
          ></app-text-input>

          <app-text-input
            label="Work Email"
            labelStyle="normal"
            type="email"
            [value]="workEmail()"
            (valueChange)="workEmail.set($event)"
          ></app-text-input>
        </div>
      </div>

      <!-- Security -->
      <div class="settings-card">
        <div class="card-header">
          <div class="header-left">
            <div class="header-icon red-bg">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EF4444" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3 class="card-title">Security</h3>
          </div>
        </div>

        <div class="card-body">
          <div class="security-row">
            <div class="row-copy">
              <span class="row-label">Password</span>
              <span class="row-sub">Last changed 30 days ago.</span>
            </div>
            <app-button variant="secondary" size="sm" (clicked)="onChangePassword()">Change Password</app-button>
          </div>

          <div class="security-row">
            <div class="row-copy">
              <span class="row-label">Two-Factor Authentication</span>
              <span class="row-sub">Add an extra layer of security to your account.</span>
            </div>
            <div class="toggle-wrap">
              <button class="toggle" [class.on]="twoFactorEnabled()" (click)="toggleTwoFactor()">
                <span class="toggle-knob"></span>
              </button>
              <span class="toggle-label">{{ twoFactorEnabled() ? 'Enabled' : 'Disabled' }}</span>
            </div>
          </div>

          <div class="sessions-block">
            <div class="row-copy">
              <span class="row-label">Active Sessions</span>
              <span class="row-sub">Devices currently signed in to your account.</span>
            </div>
            <div class="sessions-list">
              <div class="session-item" *ngFor="let s of sessions; let i = index">
                <div class="session-left">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                  <div class="session-text">
                    <span class="session-device">{{ s.device }}</span>
                    <span class="session-meta">{{ s.location }} · {{ s.status }}</span>
                  </div>
                </div>
                <span *ngIf="s.active" class="active-badge">Active</span>
                <a *ngIf="!s.active" class="signout-link" (click)="onSignOutSession(i)">Sign out</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>